import { Controller } from "@hotwired/stimulus"

// The Liked / Watched / Avoided chooser modal. Selection is optimistic: the
// rows style their checked state off aria-checked (see the
// preference_option_row partial), so flipping the attribute is all that's
// needed while the form submits. Further taps are ignored so a double tap
// can't fire twice. The server response then dismisses the modal (native) or
// redirects (web).
export default class extends Controller {
  static targets = ["option"]

  select(event) {
    if (this.locked) {
      event.preventDefault()
      return
    }
    this.locked = true

    const selected = event.currentTarget

    this.optionTargets.forEach((option) => {
      option.setAttribute("aria-checked", option === selected)
    })
  }

  clear(event) {
    if (this.locked) {
      event.preventDefault()
      return
    }
    this.locked = true

    this.optionTargets.forEach((option) => {
      option.setAttribute("aria-checked", false)
    })
  }
}
